<section class="footer-public font-sm d-flex justify-content-center flex-column">
    <div class="upper-block d-flex py-4 justify-content-between">
        <div class="d-flex left-block">
            <a class="pe-4" href="mailto:support@arivis.com">{{ 'MENU.CONTACT' | translate }}</a>
            <a class="pe-4" href="https://docs.apeer.com">{{ 'MENU.WIKI' | translate }}</a>
        </div>
        <div class="right-block social">
            <a
                target="_blank"
                rel="noopener"
                href="https://twitter.com/apeer_micro?lang=de"
                class="social-icon font-l fa fa-twitter ms-0"
                title="Visit our Twitter page"
            ></a>
            <a
                target="_blank"
                rel="noopener"
                href="https://www.facebook.com/Apeermicro/"
                class="social-icon font-l fa fa-facebook-square"
                title="Visit our Facebook page"
            ></a>
            <a
                target="_blank"
                rel="noopener"
                href="https://www.linkedin.com/company/apeer/"
                class="social-icon font-l fa fa-linkedin"
                title="Visit our LinkedIn page"
            ></a>
            <a target="_blank" rel="noopener" href="https://github.com/apeer-micro" class="social-icon font-l fa fa-github" title="Visit our Github page"></a>
            <a
                target="_blank"
                rel="noopener"
                href="https://www.youtube.com/channel/UCVrG0AsRMb0pPcxzX75SusA"
                class="social-icon font-l fa fa-youtube-play"
                title="Visit our YouTube page"
            ></a>
        </div>
    </div>
    <div class="lower-block d-flex justify-content-between py-4">
        <div class="d-flex left-block">
            <a class="pe-4" href="https://www.zeiss.com/data-protection">{{ 'MENU.DATA_PROTECTION' | translate }}</a>
            <a class="pe-4" [href]="landingPageUrl + 'publisher'">{{ 'MENU.PUBLISHER' | translate }}</a>
        </div>
        <a href="https://www.zeiss.de/mikroskopie/home.html" target="_blank" rel="noopener">{{ 'MENU.ZEISS_INITIATIVE' | translate }}</a>
    </div>
</section>
